import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseApiKey = process.env.REACT_APP_FIREBASE_API_KEY

const firebaseConfig = {
    apiKey: `${firebaseApiKey}`,
    authDomain: "brainbet.firebaseapp.com",
    projectId: "brainbet",
    storageBucket: "brainbet.firebasestorage.app",
    messagingSenderId: "1048189594259",
    appId: "1:1048189594259:web:0fda5a6f0b2c009322fb66",
    measurementId: "G-WG1KWCWJ8Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);

